import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { usePermissions } from '../contexts/PermissionContext';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import SecurityIcon from '@mui/icons-material/Security';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

const StatusContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: '90px',
  right: '20px',
  zIndex: 1000,
  display: 'flex',
  gap: '8px',
}));

const PermissionStatus = () => {
  // All access level badges removed as per user request
  return null;
};

export default PermissionStatus;
